const workflow = {
  title: "Workflow",
  description: "Create and manage workflows for your workspaces",
  nodesPalette: "Nodes Palette",
  savedSuccessfully: "Workflow saved successfully",
  createNode: "Create Node",
  test: {
    completed: "Workflow completed",
    completedDescription: "The workflow was executed successfully.",
    start: 'Start Test',
    stop: 'Stop Test',
    pause: 'Pause',
    resume: 'Continue',
    stopped: 'Workflow test stopped successfully',
    stopped_error: 'Error stopping workflow test',
    paused: 'Workflow test paused',
    paused_error: 'Error pausing workflow test',
    resumed: 'Workflow test resumed',
    resumed_error: 'Error resuming workflow test',
    webhook_timeout: 'Timeout waiting for webhook',
    no_nodes: 'Add at least one node to your workflow before testing',
    error: 'Error executing the workflow',
    success: 'Workflow executed successfully',
    running: 'Running workflow...',
    start_button: "Test Workflow",
    testing: "Testing...",
    success_title: "Test completed",
    success_description: "The workflow test was completed successfully",
    error_title: "Test error",
    error_description: "An error occurred during the test: {{error}}",
    start_error: "Error starting the test: {{error}}",
    trigger_timeout_title: "Trigger timeout",
    trigger_timeout_description: "The waiting time for the trigger has expired",
    webhook_received_title: "Webhook received",
    webhook_received_description: "The webhook was successfully received and the flow will continue",
    copied_to_clipboard: "URL copied to clipboard"
  },
  webhook: {
    title: "Webhook URL (Frontend)",
    public: "Public",
    copyUrl: "Copy URL",
    copied: "Copied!",
    open: "Open",
    proxyInfo: "This URL uses the frontend proxy to forward requests to the backend securely.",
    usageInfo: "Configure this URL in external tools like Jira, Azure DevOps, Confluence, etc.",
    waiting_title: 'Waiting for Webhook',
    waiting_message: 'Waiting for webhook response. Time remaining:',
    waiting_message_simple: 'Please wait while the webhook is being processed',
    url: 'Webhook URL',
    url_help: 'Use this URL to send data to the webhook',
    copy_url: 'Webhook URL copied to clipboard',
    copy_error: 'Error copying webhook URL',
    error: {
      timeout: 'Timeout waiting for webhook response'
    },
    confirm_stop_title: 'Stop Workflow?',
    confirm_stop_description: 'Closing this window will stop the running workflow. Do you want to continue?',
    stop_workflow: 'Stop Workflow',
    filter: {
      title: 'Webhook Filters',
      conditions: {
        add: 'Add Condition'
      },
      
      description: 'Configure filters to process webhook data',
      addFilter: 'Add Filter',
      addArrayFilter: 'Add Array Filter',
      removeFilter: 'Remove Filter',
      path: 'Path',
      pathPlaceholder: 'e.g., user.name',
      operation: 'Operation',
      value: 'Value',
      valuePlaceholder: 'Enter value',
      dataType: 'Data Type',
      arrayPath: 'Array Path',
      arrayPathPlaceholder: 'Property inside the array',
      arrayOperation: 'Array Operation',
      nestedFilters: 'Nested Filters',
      operations: {
        equals: 'Equals',
        contains: 'Contains',
        startsWith: 'Starts with',
        endsWith: 'Ends with',
        greaterThan: 'Greater than',
        lessThan: 'Less than',
        exists: 'Exists',
        notExists: 'Does not exist'
      },
      arrayOperations: {
        some: 'Some (at least one)',
        every: 'Every (all)',
        none: 'None'
      },
      filterTitle: 'Filter {{index}}',
      arrayFilterTitle: 'Array Filter {{index}}',
      conditionTitle: 'Condition {{index}}',
      cardTitle: 'Data Filter',
      cardDescription: 'Define conditions to filter incoming data. Only data that matches these conditions will be processed by the workflow.'
    }
  },
  error: {
    save_connection: "Error saving connection",
    save_schema: "Error saving schema",
    webhook_registration_failed: "Failed to register webhook",
    server_error: "Server error",
    test_failed: "Test failed",
    unknown: "Unknown error",
    no_webhook_trigger: "No webhook trigger",
    no_webhook_trigger_desc: "The workflow must have a webhook_trigger node to be tested"
  },
  nodeExecutedSuccessfully: "Node executed successfully",
  nodeSavedSuccessfully: "Node configuration saved successfully",
  nodes: {
    common: {
      input: "Input",
      output: "Output",
      conditions: "Conditions",
      defaultOutput: "Default Output",
      noInputYet: "No input yet!",
      noOutputYet: "No output yet!",
      runNodeToSeeOutput: "Run this node to see the output",
      runPreviousNodeToSeeInput: "Run the previous node to see the input"
    },
    rag_assistant: {
      title: "RAG Assistant",
      description: "Generate responses using RAG (Retrieval-Augmented Generation)",
      response_format: {
        label: "Response Format",
        description: "Choose the output format for the LLM response",
        placeholder: "Select response format",
        options: {
          text: "Text",
          json_schema: "JSON Schema",
          json_object: "JSON Object"
        }
      },
      json_schema: {
        label: "JSON Schema",
        description: "Define the JSON schema structure that the LLM should follow when returning a response",
        placeholder: "{\n  \"type\": \"object\",\n  \"properties\": {\n    \"field\": { \"type\": \"string\" }\n  }\n}"
      },
      errors: {
        json_schema_required: "JSON Schema is required when Response Format is 'json_schema'",
        invalid_json: "Invalid JSON format",
        schema_must_be_object: "JSON Schema must be an object",
        schema_missing_type: "JSON Schema must have a 'type' property"
      }
    },
    if_then: {
      title: "If...then",
      description: "Execute different paths based on a condition",
      conditions: {
        list: "List of conditions to evaluate",
        value: "Value",
        operator: "Operator",
        compareValue: "Compare Value",
        valueToEvaluate: "Value to evaluate",
        valueToCompareAgainst: "Value to compare against",
        combineWithNext: "Combine with next condition",
        howToCombine: "How to combine with next condition",
        addItem: "Add condition",
        selectOperator: "Select operator",
        selectCombine: "Select combination"
      },
      operators: {
        equals: "Equals",
        notEquals: "Not equals",
        greaterThan: "Greater than",
        lessThan: "Less than",
        greaterThanOrEqual: "Greater than or equal to",
        lessThanOrEqual: "Less than or equal to",
        contains: "Contains",
        notContains: "Does not contain",
        startsWith: "Starts with",
        endsWith: "Ends with",
        empty: "Empty",
        notEmpty: "Not empty"
      },
      combiners: {
        and: "AND",
        or: "OR"
      },
      defaultOutput: "Output when no conditions match (else)"
    }
  },
  edge: {
    deleteSuccess: "Success",
    deleteSuccessDescription: "Connection removed successfully",
    deleteError: "Error",
    deleteErrorDescription: "Error removing connection"
  },
  schedule: {
    executed: "Schedule Executed",
    executedDescription: "The workflow was executed at the scheduled time.",
    active: "Active Schedule",
    nextExecution: "Next Execution In:",
    config: "Schedule Configuration",
    expression: "Expression:",
    timezone: "Timezone:",
    autoExecute: "The workflow will be executed automatically at the scheduled time.",
    stop: "Stop Workflow",
    stopConfirm: "Are you sure you want to stop the workflow execution? The schedule will be cancelled."
  },
  nodeConfig: {
    validationError: "Validation error",
    validationErrorDescription: "Check the form fields"
  },
  email: {
    contentLabel: "Email Content",
    customHtml: "Custom HTML",
    loadingTemplates: "Loading...",
    selectTemplate: "Select a template",
    noTemplate: "— None —",
    customBadge: "custom",
    noTranslation: "This template has no translation available.",
    subjectOverrideLabel: "Subject (optional — overrides the template subject)",
    keepOriginalSubject: "Keep original template subject",
    mapVariables: "Map template variables",
    variable: "Variable",
    value: "Value",
    workflowField: "Workflow field",
    freeValuePlaceholder: "Free value or {{input.*}}",
    notMapped: "— not mapped —",
    noInputFields: "no input fields",
    useWorkflowField: "Use workflow field",
    typeManually: "Type value manually",
    templateDetails: "Template details",
    originalSubject: "Original subject: ",
    preview: "Preview",
    previewTitle: "Preview: {{name}}",
    subject: "Subject",
    subjectPlaceholder: "Email subject. Supports {{input.*}}",
    bodyHtml: "Body (HTML)",
    hidePreview: "Hide preview",
    nothingToPreview: "Nothing to preview",
    autoFilledVariables: "Variables automatically filled by the workflow:",
    key: "Key",
    description: "Description",
    example: "Example",
    dynamicLanguageLabel: "Language (placeholder)",
    useFixedLanguage: "Switch back to fixed selection",
    useDynamicLanguage: "Use dynamic placeholder"
  }
} as const;

export default workflow;
